jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    // Mobile Footer Menus
    if ($(window).width() <= 767) {
        // Changing widgettitle from span to button for accessibility
        $(".footerRow .linkWrapper__widgets li.widget .widgettitle").replaceWith(function() { 
            return "<button class='widgettitle' role='heading' aria-level='3'>" + this.innerHTML + "</button>"; 
        });

        $('.footerRow .linkWrapper__widgets .widget').on('click', function() {
            $(this).toggleClass('active').siblings().removeClass('active');
            $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
        });
    }

    // Place Homepage only Javascript inside of IF statement
    // if (document.body.classList.contains('home')) {
    // 
    // }

});